var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndpoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_5825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1733 3.61353H4.28956C3.91438 3.61353 3.61035 3.91757 3.61035 4.29277V15.1207",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#00BDD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76904 20.3892H19.7091C20.0843 20.3892 20.3884 20.0852 20.3884 19.71V8.82568",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#00BDD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22024 20.3908C6.22024 21.8324 5.05165 23.001 3.61012 23.001C2.16859 23.001 1 21.8324 1 20.3908C1 18.9492 2.16859 17.7805 3.61012 17.7805C5.05165 17.7805 6.22024 18.9492 6.22024 20.3908Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#00BDD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9981 3.61124C22.9981 5.05285 21.8295 6.2215 20.388 6.2215C18.9464 6.2215 17.7778 5.05285 17.7778 3.61124C17.7778 2.16963 18.9464 1.00098 20.388 1.00098C21.8295 1.00098 22.9981 2.16963 22.9981 3.61124Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#00BDD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7935 14.7039H9.391V9.3011H14.7935V14.7039Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#00BDD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4971 9.50144L18.5545 5.44409",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#00BDD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45605 18.5412L9.60245 14.3945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#00BDD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_5825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9976,
    height: 24.0018,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpoint);
export default __webpack_public_path__ + "static/media/endpoint.9b3dbc614fe4f7647f4274b81eae55e4.svg";
export { ForwardRef as ReactComponent };